document.addEventListener('DOMContentLoaded', function () {
  var bar = document.getElementById('sticky-atc-bar');
  var select = document.getElementById('sticky-atc-variant-select');
  var priceEl = document.getElementById('sticky-atc-price-current');
  var discountEl = document.getElementById('sticky-atc-discount');
  var addBtn = document.getElementById('sticky-atc-add');
  var buyBtn = document.getElementById('sticky-atc-buy');
  var buyIdInput = document.getElementById('sticky-atc-buy-id');
  var product = window.stickyAtcProduct;

  if (!bar || !product) return;

  function getVariant(id) {
    return product.variants.find(function (v) { return v.id == id; });
  }

  function formatMoney(cents) {
    return '₹' + (cents / 100).toLocaleString('en-IN');
  }

  function updateUI(variant) {
    if (!variant) return;
    priceEl.textContent = formatMoney(variant.price);
    if (variant.compare_at_price && variant.compare_at_price > variant.price) {
      var pct = Math.round(((variant.compare_at_price - variant.price) / variant.compare_at_price) * 100);
      if (discountEl) {
        discountEl.textContent = pct + '% off';
        discountEl.style.display = 'inline-block';
      }
    } else if (discountEl) {
      discountEl.style.display = 'none';
    }
    var available = variant.available;
    addBtn.disabled = !available;
    if (buyBtn) {
      buyBtn.classList.toggle('sticky-atc-buy-wrap--disabled', !available);
    }
    if (buyIdInput) {
      buyIdInput.value = variant.id;
    }
  }

  if (select) {
    select.addEventListener('change', function () {
      updateUI(getVariant(this.value));
      // Keep in sync with the main product form's variant selector, if present
      var mainSelect = document.querySelector('[name="id"]');
      if (mainSelect) {
        mainSelect.value = this.value;
        mainSelect.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
  }

  // Keep the Shiprocket Buy Now form's hidden variant id in sync with the
  // main product form's variant selector too, in case it changes elsewhere
  // on the page (e.g. swatches) without going through the sticky select.
  var mainVariantInput = document.querySelector('[name="id"]');
  if (mainVariantInput && buyIdInput) {
    mainVariantInput.addEventListener('change', function () {
      buyIdInput.value = this.value;
    });
  }

  function currentVariantId() {
    return select ? select.value : product.variants[0].id;
  }

  addBtn.addEventListener('click', function () {
    addBtn.disabled = true;
    addBtn.textContent = 'Adding...';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: currentVariantId(), quantity: 1 })
    })
      .then(function (res) { return res.json(); })
      .then(function () {
        addBtn.textContent = 'Added ✓';
        document.dispatchEvent(new CustomEvent('cart:updated'));
        setTimeout(function () {
          addBtn.textContent = 'Add to Cart';
          addBtn.disabled = false;
        }, 1500);
      })
      .catch(function () {
        addBtn.textContent = 'Add to Cart';
        addBtn.disabled = false;
      });
  });

  // Buy Now is now handled entirely by the Shiprocket headless checkout
  // widget rendered inside #sticky-atc-buy (see snippets/sticky-add-to-cart.liquid),
  // the same way every other Buy Now button in this theme works. No manual
  // click/redirect handler is needed here anymore.

  // Show the bar once the main Add to Cart button scrolls out of view
  var mainAtc = document.querySelector('[name="add"], .product-form__submit, button[type="submit"]');
  if (mainAtc) {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        bar.classList.toggle('is-visible', !entry.isIntersecting);
      });
    }, { threshold: 0 });
    observer.observe(mainAtc);
  } else {
    window.addEventListener('scroll', function () {
      bar.classList.toggle('is-visible', window.scrollY > 400);
    });
  }
});